<template>
  <div>
    <v-card shaped width="250" height="300" class="elevation-10">
      <v-card-title class="my-0 py-0">
        <v-col justify="start" class="mx-0 px-0">
          <v-row align="center">
            <v-col cols="8">
              <v-row justify="start" class="ml-2">
                <span class="body-2 font-weight-bold">{{ idea.title }}</span>
              </v-row>
            </v-col>
            <v-col cols="4">
              <v-row justify="space-between" style="margin-right: -8px">
                <ideaEditor></ideaEditor>
                <v-btn small outlined class="elevation-16" icon @click="editIdea">
                  <v-icon color="black" small>mdi-pencil</v-icon>
                </v-btn>
                <v-btn small outlined class="elevation-16" icon @click="remove(idea._id)">
                  <v-icon color="black" small>mdi-delete</v-icon>
                </v-btn>
              </v-row>
            </v-col>
          </v-row>
          <v-row class="caption ml-0 pt-0" align="center" justify="start">
            <span class="px-2">{{ idea.upVote }}</span>
            <v-icon small color="green">mdi-arrow-up</v-icon>
            <v-icon class="px-1" small>mdi-arrow-collapse-horizontal</v-icon>
            <v-icon small color="red">mdi-arrow-down</v-icon>
            <span class="px-2">{{ idea.downVote }}</span>
          </v-row>
        </v-col>
      </v-card-title>
      <v-card-text>
        <span id="desc">{{ idea.description }}</span>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import ideaEditor from "@/components/IdeaEditor";
import { mapActions, mapMutations, mapState } from "vuex";

export default {
  components: {
    ideaEditor
  },
  props: {
    idea: {
      type: Object,
      required: true
    }
  },
  data() {
    return {};
  },
  computed: {
    ...mapState("idea", ["dialog", "editedIdea", "defaultIdea"])
  },
  methods: {
    ...mapActions("idea", ["remove"]),
    ...mapMutations("idea", ["setDialog", "setEditedIdea"]),
    editIdea() {
      this.setEditedIdea(this.idea);
      this.setDialog(true);
    }
  }
};
</script>

<style scoped>
#desc {
  overflow: hidden;
  /* margin-top: -15px; */
  width: 100%;
  display: -webkit-box;
  -webkit-line-clamp: 9;
  -webkit-box-orient: vertical;
}
</style>